export default {
  118: 'Nordicbet',
  332: 'Betsafe',
  567: 'Bovada',
  539: 'Marathonbet',
  126: 'Bet 365',
  6: 'Unibet / 32red / 888sport'
}



/** WEBPACK FOOTER **
 ** ./src/config/hobbyBookmakers.js
 **/